import {
    Component,
    OnDestroy,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { StepNavigationService } from '../../../../modules/application/shared/services/step-navigation/step-navigation.service';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { StepLink } from '../../../../modules/application/shared/models/step-link';
import { StepNavigationButtonVisibilityService } from '../../../../modules/application/shared/services/step-navigation-button-visibility/step-navigation-button-visibility.service';

@Component({
    selector: 'app-application-footer',
    templateUrl: './application-footer.component.html',
    styleUrls: ['./application-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule],
})
export class ApplicationFooterComponent implements OnInit, OnDestroy {
    showPreviousButton = false;
    showNextButton = true;

    private destroy$ = new Subject<void>();

    constructor(
        private readonly stepNavigationOptionsService: StepNavigationButtonVisibilityService,
        private readonly stepService: StepNavigationService,
    ) {}

    ngOnInit(): void {
        this.watchCurrentStepChanges();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    next() {
        this.stepService.triggerNextClick();
    }

    previous() {
        this.stepService.triggerPreviousClick();
    }

    private watchCurrentStepChanges(): void {
        this.stepService.currentStep$
            .pipe(
                takeUntil(this.destroy$),
                filter(
                    (currentStep): currentStep is StepLink =>
                        currentStep !== undefined,
                ),
                tap((currentStep: StepLink) => {
                    this.setNavigationLinks(currentStep);
                }),
            )
            .subscribe();
    }

    private setNavigationLinks(stepLink: StepLink) {
        this.setNextButtonVisibility(stepLink);
        this.setPreviousButtonVisibility(stepLink);
    }

    private setNextButtonVisibility(stepLink: StepLink) {
        this.showNextButton =
            this.stepNavigationOptionsService.needsNextButton(stepLink);
    }

    private setPreviousButtonVisibility(stepLink: StepLink) {
        this.showPreviousButton =
            this.stepNavigationOptionsService.needsPreviousButton(stepLink);
    }
}
